import { httpClient } from "../../../lib/http/axios";
import type { ApiEnvelope } from "../../../lib/http/contracts";

export interface ContactMergeEvent {
  id: number;
  eventType: string;
  fromStatus?: string;
  toStatus?: string;
  stage?: string;
  operatorUserId: number;
  payload?: Record<string, unknown>;
  errorCode?: string;
  errorSummary?: string;
  createdAt: string;
}

interface ContactMergeEventRaw {
  id: number;
  event_type: string;
  from_status?: string | null;
  to_status?: string | null;
  stage?: string | null;
  operator_user_id: number;
  payload?: Record<string, unknown> | null;
  error_code?: string | null;
  error_summary?: string | null;
  created_at: string;
}

/** 读取联系人合并审计事件。 */
export async function fetchContactMergeEvents(taskId: number): Promise<ContactMergeEvent[]> {
  const response = await httpClient.get<ApiEnvelope<ContactMergeEventRaw[]>>(
    `/crm/contact-merges/${taskId}/events`,
  );
  if (response.data.code !== "OK" || !response.data.data) {
    throw new Error("审计事件接口返回了无效数据");
  }
  return response.data.data.map((item) => ({
    id: item.id,
    eventType: item.event_type,
    fromStatus: item.from_status ?? undefined,
    toStatus: item.to_status ?? undefined,
    stage: item.stage ?? undefined,
    operatorUserId: item.operator_user_id,
    payload: item.payload ?? undefined,
    errorCode: item.error_code ?? undefined,
    errorSummary: item.error_summary ?? undefined,
    createdAt: item.created_at,
  }));
}
